import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { DocumentViewModel } from '../../../business-entities/document-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../../../../../Widget/src/app/services/commom.service';
import { Constant } from '../../../utils/constant';
import { UploadDocumentRequestModel } from '../../../business-entities/upload-document-request-model';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.css']
})
export class UploadDocumentComponent implements OnInit {
  uploadImagedata: FormGroup;
  DocumentsArray: DocumentViewModel[] = [];
  imagesize: any;
  image: string;
  imageBaseData: string | ArrayBuffer = null;
  imageSelected: boolean = false;
  allowExtension = Constant.ServiceDocUploadExts;
  @Input() uniqueId: number = 0;
  constructor(
    public activeModal: NgbActiveModal,
    public fb: FormBuilder,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.uploadImagedata = this.fb.group({
      comment: [null, [Validators.required]],
      Documents: [[]]
    });
    let localDocs = this.commonService.getDocument(this.uniqueId);
    this.DocumentsArray = (localDocs[0]?.Documents) ? localDocs[0].Documents : [];
    this.uploadImagedata.patchValue({
      comment: (localDocs[0]?.comment) ? localDocs[0].comment : ""
    })
    this.CheckDocs();
  }

  showPreview(event) {
    let files = event.target.files;
    let maxfileSize = 50 * 1024 * 1024 // 50 MB
    for (let idx = 0; idx < files.length; idx++) {
      let ext = "." + files[idx]?.name?.split('.')?.pop();
      let extensionsAllowed = this.allowExtension?.split(",");
      if (this.DocumentsArray.filter(x => x.image == files[idx]?.name)?.length > 0) {
        let errormsg = this.translate.instant("lblFileAlreadySelected") + files[idx]?.name;
        this.toastr.error(errormsg);
      }
      else if(extensionsAllowed?.filter(t => t?.toLowerCase() == ext?.toLowerCase())?.length <= 0){
        let errormsg = this.translate.instant("lblFileTypeNotAllowed");
        this.toastr.error(errormsg);
      }
      else {
        this.image = URL.createObjectURL(files[idx]);
        this.imagesize = files[idx]?.size;
        const reader = new FileReader();
        reader.readAsDataURL(files[idx]);
        let obj: DocumentViewModel = {
          image: files[idx]?.name,
          mimeType: files[idx]?.type,
          imageBinaryData: '',
          actualFile: files[idx],
          src: this.image,
          extension: ext,
          isImage: false,
          size: this.imagesize
        }
        //this.uploadImagedata.controls["MimeType"].setValue(files[idx]?.type);
        //this.uploadImagedata.controls["Image"].setValue(files[idx]?.name);
        if (this.imagesize <= maxfileSize) {
          reader.onload = (_readerEvent) => {
            this.imageBaseData = reader.result;
            obj.imageBinaryData = reader.result.toString().replace('data:' + obj.mimeType + ';base64,', '');
            //this.uploadImagedata.value.ImageBinaryData=reader.result.toString().replace('data:' + this.uploadImagedata.value.MimeType + ';base64,', '');
          };

          this.DocumentsArray.push(obj);
          this.uploadImagedata.patchValue({
            Documents: this.DocumentsArray
          })
        }
        else {
          let errormsg = this.translate.instant("lblMaxSizeAllowed50MB") + files[idx]?.name;
          this.toastr.error(errormsg);
        }
      }
    }
    this.CheckDocs();
  }

  CheckDocs() {
    this.imageSelected = (this.DocumentsArray?.length > 0) ? true : false;
  }

  async UploadImage(_data) {
    let docs = this.DocumentsArray.map(x => Object.assign({}, x));
    let model: UploadDocumentRequestModel = {
      comment: this.uploadImagedata?.value?.comment,
      Documents: docs,
      uniqueId: this.uniqueId,
      appointmentId: 0
    }
    this.commonService.addDocument(model);
    this.activeModal.close({ success: true });
  }
  RemoveImage(index: number) {
    let docs = this.DocumentsArray.splice(index, 1)
    this.uploadImagedata.patchValue({
      Documents: docs
    })
    this.CheckDocs();
  }

  get cpf() {
    return this.uploadImagedata.controls;
  }

}
